// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_errorboundarymessage2 = /** @type {(inputs: {}) => string} */ () => {
	return `Oops! Something unexpected happened. Don't worry, we've logged this issue and our team will take a look.`
};

const de_errorboundarymessage2 = /** @type {(inputs: {}) => string} */ () => {
	return `Hoppla! Etwas Unerwartetes ist passiert. Keine Sorge, wir haben dieses Problem protokolliert und unser Team wird es sich ansehen.`
};

const es_errorboundarymessage2 = /** @type {(inputs: {}) => string} */ () => {
	return `¡Ups! Algo inesperado ocurrió. No te preocupes, hemos registrado este problema y nuestro equipo lo revisará.`
};

const fr_errorboundarymessage2 = /** @type {(inputs: {}) => string} */ () => {
	return `Oups ! Quelque chose d'inattendu s'est produit. Ne vous inquiétez pas, nous avons enregistré ce problème et notre équipe va y jeter un coup d'œil.`
};

const ja_errorboundarymessage2 = /** @type {(inputs: {}) => string} */ () => {
	return `おっと！予期しないことが発生しました。ご心配なく、この問題を記録し、私たちのチームが確認いたします。`
};

const nl_errorboundarymessage2 = /** @type {(inputs: {}) => string} */ () => {
	return `Oeps! Er is iets onverwachts gebeurd. Maak je geen zorgen, we hebben dit probleem geregistreerd en ons team zal ernaar kijken.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "ja" | "nl" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const errorboundarymessage2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.errorboundarymessage2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("errorboundarymessage2", locale)
	if (locale === "en") return en_errorboundarymessage2(inputs)
	if (locale === "de") return de_errorboundarymessage2(inputs)
	if (locale === "es") return es_errorboundarymessage2(inputs)
	if (locale === "fr") return fr_errorboundarymessage2(inputs)
	if (locale === "ja") return ja_errorboundarymessage2(inputs)
	return nl_errorboundarymessage2(inputs)
};
export { errorboundarymessage2 as "errorBoundaryMessage" }